export const ZOHO_TOKEN =
  '4ab47b7e09bfa42162694ee1c5e5a0cb579b0525328650f38681a9788e1ce6b6752bceecad57b06fddc47706c9ed5e56';

export const LOGO_BASE_URL = 'https://salesiq.zoho.com';
